import { createFileRoute } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { Pricing } from "@/features/site/modules/pricing/pricing";
import type { TrainerLoaderData } from "@/features/site/utils/trainer-head";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/$trainerSlug/pricing/")({
  component: PricingPage,
  // The packs and plans are read before the page draws, so they are in the server's HTML with the
  // services above them.
  loader: async ({ parentMatchPromise }) => {
    // Named by hand: with its `head` reading the loader's data too, the router infers the layout's as `never`.
    const loaded = (await parentMatchPromise).loaderData as TrainerLoaderData | undefined;
    const organizationId = loaded?.page.organizationId;
    const { data } = organizationId
      ? await sdk.publicOffers.$get.setQueryParams({ organizationId }).send()
      : { data: null };
    return { crumb: m.landing_nav_pricing(), offers: data ?? undefined };
  },
});

function PricingPage() {
  const { offers } = Route.useLoaderData();
  return <Pricing offers={offers} />;
}
